import { render, staticRenderFns } from "./SuitSymbol.vue?vue&type=template&id=25949c30&scoped=true&"
import script from "./SuitSymbol.vue?vue&type=script&lang=js&"
export * from "./SuitSymbol.vue?vue&type=script&lang=js&"
import style0 from "./SuitSymbol.vue?vue&type=style&index=0&id=25949c30&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25949c30",
  null
  
)

export default component.exports